import { Link } from "react-router-dom";

const CTA_IMG =
  "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20wooden%20film%20clapperboard%20resting%20on%20a%20table%20beside%20scripts%20and%20a%20warm%20desk%20lamp%2C%20golden%20hour%20light%20spilling%20across%20a%20dark%20table%2C%20cinematic%20still%20life%2C%20moody%20amber%20tone%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20elegant%20atmospheric%20photography&width=1400&height=1100&seq=home-cta-clapper&orientation=portrait";

export default function Cta() {
  return (
    <section className="border-t border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid overflow-hidden rounded-2xl border border-background-200 bg-background-100 lg:grid-cols-2">
          <div className="flex flex-col justify-center p-7 md:p-12">
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-400 uppercase">
              <i className="ri-film-line" /> 幕外的理由
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              我们相信，
              <br className="hidden md:block" />
              好故事从来不止一版
            </h2>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
              每一部小电影的正片背后，都站着几十个不眠的夜晚与一群不肯将就的人。幕外想做的，只是把这些“不被看见”的付出，稳稳地记录下来。
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/about"
                className="inline-flex h-11 items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 text-sm font-semibold text-foreground-100 transition hover:bg-primary-400"
              >
                认识幕外 <i className="ri-arrow-right-line ml-2" />
              </Link>
              <Link
                to="/column"
                className="inline-flex h-11 items-center justify-center whitespace-nowrap rounded-md border border-background-300 px-5 text-sm font-medium text-foreground-900 transition hover:border-primary-400 hover:text-primary-200"
              >
                去翻档案
              </Link>
            </div>
          </div>
          <div className="relative min-h-[260px] lg:min-h-0">
            <img
              src={CTA_IMG}
              alt="桌面上的场记板与剧本剪影"
              className="absolute inset-0 h-full w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-100 via-background-100/20 to-transparent max-lg:bg-gradient-to-t max-lg:from-background-100/70 max-lg:to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}